<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group class="col-12 my-0 pb-0">
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
            >
              <label style="font-size: 1rem">Pacote Ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Nome"
            >
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Nome"
              >
                <b-form-input
                  v-model="form.nome"
                  :state="errors.length > 0 ? false:null"
                  @change="validaNomeCompetencia()"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="existePacote"
                  class="text-danger"
                >
                  Nome já cadastrado para a competência selecionada
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <legend class="col-form-label pt-0">
              Competência
            </legend>
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Competência"
            >
              <vue-monthly-picker
                v-model="form.competencia"
                :input-class="'input-sm form-control w-100'"
                :date-format="'MM/YYYY'"
                :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
                :alignment="'left'"
                @selected="validaNomeCompetencia"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <!-- <b-col cols="3">
            <legend
              tabindex="-1"
              class="bv-no-focus-ring col-form-label pt-0"
            >&nbsp;</legend>
            <b-form-checkbox
              v-model="form.utilizarNaChecklist"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem;"
            >
              Utilizar no checklist
            </b-form-checkbox>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Tipo de pacote">
              <b-select
                v-model="form.tipo"
                :required="true"
                @change="onChangeTipoPacote"
              >
                <option
                  v-for="(opcao, $index) in tipoPacoteOpcoes"
                  :key="$index"
                  :value="opcao.value"
                >{{ opcao.text }}</option>
              </b-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="form.tipo === 'honorarios'"
            cols="6"
          >
            <b-form-group label="Nível">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Nível"
              >
                <b-select
                  v-model="form.nivel"
                  :required="true"
                  @change="function() {}"
                >
                  <option
                    v-for="(opcao, $index) in nivelPacoteOpcoes"
                    :key="$index"
                    :value="opcao.value"
                  >{{ opcao.text }}</option>
                </b-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Selecão de serviços -->
        <b-row>
          <b-col
            cols="12"
            class="mt-2"
          >
            <h4>Seleção de Serviços</h4>
            <fieldset class="font-weight-bold text-muted small">
              Selecione os serviços que deseja vincular a esse pacote
            </fieldset>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col v-if="(form.tipo === 'servicos' && form.servicos) || (form.tipo === 'honorarios' && form.servicosComHonorario)">
            <p
              v-if="possuiProposta"
              class="aviso"
            >Atenção: A ação de adicionar ou remover os serviços desse pacote, impacta no valor total do mesmo. As propostas que já estiverem cadastradas com esse pacote  não sofrem alteração, somente novas propostas cadastradas.</p>
            <selecao-servicos
              ref="selecaoservicos"
              :value="form.servicos"
              :mostrar-selecionados="form.id > 0 && mostrarSelecionados"
              :valor-total="form.valorPacote"
              :is-honorario="form.tipo === 'honorarios'"
              :servicos-com-honorario="form.servicosComHonorario"
              @valor-total="setValorTotal($event)"
              @selecionado-servico="servicoSelecionado($event)"
            >
              <template slot="valor-total">
                <div class="valor-total">
                  <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                  <strong>Total do pacote: {{ valueAttr !== 0 ? parseFloat(valueAttr.toFixed(2)).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency', minimumFractionDigits: 2 }) : 'R$ 0' }}</strong>
                </div>
              </template>
            </selecao-servicos>
          </b-col>
        </b-row>

        <b-row>
          <b-form-group
            label="Descrição complementar"
            class="col-12 mt-2"
          >
            <b-textarea
              v-model="form.observacao"
              placeholder="Descreva mais informações sobre esse pacote para a pessoa que irá receber a proposta"
            />
          </b-form-group>
        </b-row>

        <!-- Mensagem de reajuste
        <div v-if="form.desatualizado && !form.confirmado">
          <div class="aviso">
            O valor do pacote de serviços está desatualizado, pois existem serviços com reajuste de valor. Faça uma cópia desse pacote para realizar a atualização dos valores.
          </div>
        </div>
        <div v-if="form.desatualizado">
          <b-row>
            <b-col cols="6">
              <b-form-checkbox
                v-model="form.confirmado"
                :value="true"
                :unchecked-value="false"
                style="margin-top: 0.7rem;"
                :disabled="form.confirmado"
                @change="mensagemAviso"
              >
                Ciente do Reajuste. Não exibir mensagem novamente!
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <div
                style="display:flex; word-wrap: break-word;"
              >
                <p
                  v-if="form.confirmado && form.usuarioMarcou != null"
                  style="font-size:12px;"
                  class="form-text text-muted textbox"
                >
                  <strong style="font-weight:bold;">Marcado em: </strong>{{ format(form.dataMarcado) }}<br>
                  <strong style="font-weight:bold;">Usuário:</strong> {{ form.usuarioMarcou }}
                </p>
              </div>
            </b-col>
          </b-row>
        </div> -->
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.start-date input.form-control {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

.display-text {
    height: 100%;
  }

.vue-monthly-picker .month-picker-wrapper {
  min-width: 0px !important;
}

.aviso {
  text-align: left;
  font-size: 15.5px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;

  p{
    margin:0
  }
}

.valor-total {
  float: right;
  width: 23.2rem;
  font-size: 16px;
}
</style>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import moment from 'moment'
import VueMonthlyPicker from 'vue-monthly-picker'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/pacote-servico/shared/services/api'

export default {
  name: 'PacoteServicos',
  components: {
    CadastroBase,
    ValidationProvider,
    VueMonthlyPicker,
    // DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    SelecaoServicos: () => import('@/app-modulo/comercial/pacote-servico/shared/components/selecao-servicos/SelecaoServicos.vue'),
  },
  data() {
    return {
      required,
      form: {
        ativo: true,
        nome: '',
        competencia: null,
        tipo: 'honorarios',
        nivel: null,
        utilizarNaChecklist: false,
        valorPacote: 0,
        observacao: '',
        servicos: null,
        servicosComHonorario: null,
      },
      valueAttr: 0,
      valueAttrRCC: 0,
      existePacote: false,
      possuiProposta: false,
      tipoPacoteOpcoes: [
        { value: 'honorarios', text: 'Pacote de honorários' },
        { value: 'servicos', text: 'Pacote de serviços' },
      ],
      nivelPacoteOpcoes: [
        { value: 1, text: 'Nível I - Básico' },
        { value: 2, text: 'Nível II - Essencial' },
        { value: 3, text: 'Nível III - Avançado' },
      ],
      servicosDepComHonorario: [],
      servicosDepSemHonorario: [],
      mostrarSelecionados: true,
    }
  },
  computed: {
    valor: {
      get() {
        return this.valueAttr
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    valorRCC: {
      get() {
        return this.valueAttrRCC
      },
      set(newValue) {
        this.valueAttrRCC = newValue
        return this.valueAttrRCC
      },
    },
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else if (this.$route.params.copia) {
      this.carregarCopia(this.$route.params.id)
    } else {
      this.carregarServicosDepartamento()
    }
  },
  methods: {
    carregar(id) {
      this.getPossuiProposta(id)
      api.getPacoteServico(id)
        .then(payload => {
          const date = moment(payload.data.competencia, 'DD/MM/YYYY')
          const pacoteServico = payload.data
          pacoteServico.competencia = date
          this.valor = pacoteServico.valorPacote
          this.valorRCC = pacoteServico.valorRCCPacote
          this.form = pacoteServico
          this.carregarServicosDepartamento()
        })
    },
    carregarCopia(id) {
      api.getPacoteServicoCopia(id)
        .then(payload => {
          const pacoteServico = payload.data
          pacoteServico.competencia = null
          this.valor = pacoteServico.valorPacote
          this.valorRCC = pacoteServico.valorRCCPacote
          this.form = pacoteServico
          this.carregarServicosDepartamento()
        })
    },
    carregarServicosDepartamento() {
      api.getServicosDepartamentos()
        .then(payload => {
          this.servicosDepComHonorario = payload.data.servicosComHonorario
          this.servicosDepSemHonorario = payload.data.servicosSemHonorario

          if (!this.form.servicos || this.form.servicos.length === 0) {
            this.form.servicos = this.servicosDepSemHonorario
          }

          if (!this.form.servicosComHonorario || this.form.servicosComHonorario.length === 0) {
            this.form.servicosComHonorario = this.servicosDepComHonorario
          }
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível obter os serviços para seleção',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          throw err
        })
    },
    salvar() {
      const date = moment(this.form.competencia).format('DD/MM/YYYY')
      let copia = false
      if (this.$route.params.copia !== undefined) {
        copia = this.$route.params.copia
        if (copia) {
          this.$set(this.form, 'id', 0)
        }
      }
      api.existePacoteServico(this.form, date, copia)
        .then(payload => {
          if (!payload.data && !this.existePacote) {
            this.salvarPacoteServico()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Já existe um pacote cadastrado com o mesmo nome e competência',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    salvarPacoteServico() {
      return new Promise((resolve, reject) => {
        const pacoteEnviar = this.form
        pacoteEnviar.valorPacote = this.valor
        pacoteEnviar.valorRCCPacote = this.valorRCC
        if (this.state === 'novo') {
          const date = moment(this.form.competencia, 'MM/YYYY').toDate()
          pacoteEnviar.competencia = date
          api.createPacoteServico(pacoteEnviar)
            .then(() => {
              this.$router.go(-1)
              resolve('Pacote de serviço cadastrado com sucesso')
            })
            .catch(err => {
              const detalhe = err?.response?.data?.detail || ''
              const mensagem = err?.response?.data?.message
                || (detalhe.includes('Substituir itens do checklist')
                  ? 'No pacote de honorários é obrigatório selecionar exatamente um serviço com a marcação "Substituir itens do checklist por esse serviço". Verifique se o serviço escolhido possui essa marcação.'
                  : detalhe)
                || 'Não foi possível salvar o pacote de serviços. Tente novamente.'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: mensagem,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              reject(err)
            })
        } else {
          api.updatePacoteServico(this.form.id, pacoteEnviar)
            .then(() => {
              this.$router.go(-1)
              resolve('Pacote de serviço atualizado com sucesso')
            })
            .catch(err => {
              const detalhe = err?.response?.data?.detail || ''
              const mensagem = err?.response?.data?.message
                || (detalhe.includes('Substituir itens do checklist')
                  ? 'No pacote de honorários é obrigatório selecionar exatamente um serviço com a marcação "Substituir itens do checklist por esse serviço". Verifique se o serviço escolhido possui essa marcação.'
                  : detalhe)
                || 'Não foi possível salvar o pacote de serviços. Tente novamente.'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: mensagem,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    setValorTotal(valorTotalSelecionado) {
      this.valor = valorTotalSelecionado.valor
      this.valorRCC = valorTotalSelecionado.valorRCC
    },
    servicoSelecionado(servico) {
      const servicoSelecionado = this.form.tipo === 'honorarios'
        ? this.form.servicosComHonorario.find(f => f.servicoId === servico.servicoId)
        : this.form.servicos.find(f => f.departamento.id === servico.departamento.id)?.servicos.find(find => find.servicoId === servico.servicoId)

      if (servicoSelecionado != null) {
        servicoSelecionado.vgtSelected = servico.vgtSelected
        servicoSelecionado.selecionado = servico.selecionado
        servicoSelecionado.vgtDisabled = servico.vgtDisabled
      }
    },
    validaNomeCompetencia() {
      if (this.form.competencia !== null) {
        const date = moment(this.form.competencia).format('DD/MM/YYYY')
        let copia = false
        if (this.$route.params.copia !== undefined) {
          copia = this.$route.params.copia
        }
        api.existePacoteServico(this.form, date, copia)
          .then(payload => {
            if (payload.data) {
              this.existePacote = true
            } else {
              this.existePacote = false
            }
          })
      }
    },
    format(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    mensagemAviso(check) {
      if (check) {
        this.$swal({
          text: 'Ao marcar "Ciente do Reajuste. Não exibir mensagem novamente!" o sistema irá considerar que o usuário fez a cópia desse pacote com a atualização '
          + 'dos valores e irá parar de gerar as mensagens e alertas de pacote desatualizado. Tem certeza que deseja continuar?',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
        })
          .then(select => {
            if (!select.value) {
              this.form.naoExibirReajuste = false
            } else {
              this.form.naoExibirReajuste = true
            }
          })
      }
    },
    onChangeTipoPacote() {
      this.form.nivel = null
      this.valueAttr = 0
      this.$refs.selecaoservicos.valor = 0
      this.mostrarSelecionados = false
      this.form.servicos = this.servicosDepSemHonorario
      this.form.servicosComHonorario = this.servicosDepComHonorario
    },
    getPossuiProposta(id) {
      api.possuiProposta(id)
        .then(payload => {
          if (payload.data) {
            this.possuiProposta = true
          } else {
            this.possuiProposta = false
          }
        })
    },
  },
}
</script>
